module.exports = __webpack_public_path__ + "static/media/empty_state.a60b014f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/empty_state.svg
// module id = 940
// module chunks = 0